import { capitalizeString } from './capitalizeString';

export const prepareSelectLabel = label => {
  return capitalizeString(label.replace(/_/g, ' '));
};
